import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-mu",
  "use": "icon-icon-mu-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-mu\">\n  <g fill-rule=\"evenodd\">\n    <path fill=\"#009f4d\" d=\"M0 384h512v128H0z\" />\n    <path fill=\"#151f6d\" d=\"M0 128h512v128H0z\" />\n    <path fill=\"#ee2737\" d=\"M0 0h512v128H0z\" />\n    <path fill=\"#ffcd00\" d=\"M0 256h512v128H0z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol